import { Grid, Stack } from "@mui/material";
import { FileDownload, FileUploadField, Form } from "../../../components/common";
import useGetDocuments from "../../../hooks/useGetDocuments/useGetDocuments";
import { uploadDocument } from "../../../api/documents";
import { useQueryClient } from "react-query";
import { formatDate } from "../../../helpers/formatDate";

const ProfileDocuments = () => {
  const { data: documents } = useGetDocuments();
  const queryClient = useQueryClient();
  const isUploadEnabled = true;

  const files = documents?.map((document) => ({
    name: document.fileOriginalName,
    url: document['@id'],
    date: document.uploadedAt ? new Date(document.uploadedAt) : null,
  })) || [];

  return <Stack direction="column" spacing={2} width="100%" overflow="hidden" alignItems="flex-start">
    <h1>Documents</h1>
    <Stack 
      direction={{ xs: "column", md: "row" }} 
      spacing={2} 
      width="100%"
      sx={{
        '& > *': {
          minWidth: 0, // Prevents flex items from overflowing
          flexShrink: 1, // Allows items to shrink
        }
      }}
    >
      {isUploadEnabled && <Form sx={{ 
        flex: { xs: '1 1 100%', md: '1 1 45%', lg: '1 1 40%' },
        maxWidth: { xs: '100%', md: '45%', lg: '40%' },
        minWidth: { xs: '100%', md: '300px' }
      }}>
        <FileUploadField
          id="fileUpload"
          name="fileUpload"
          title={"Upload a file"}
          uploadLabel=""
          helperText={"Supported formats: .jpeg, .png, .pdf"}
          allowedTypes={[".jpeg", ".jpg", ".png", ".pdf"]}
          fileUploadType={"TYPE_ID"}
          uploadFile={uploadDocument}
          onSuccess={() => {
            queryClient.invalidateQueries({ queryKey: ['get-documents'], exact: true })
          }}
          resetStateOnSuccess
          required
        />
      </Form>}
      <Grid 
        container 
        spacing={2} 
        sx={{ 
          flex: { xs: '1 1 100%', md: isUploadEnabled ? '1 1 55%' : '1 1 100%', lg: isUploadEnabled ? '1 1 60%' : '1 1 100%' },
          maxWidth: { xs: '100%', md: isUploadEnabled ? '55%' : '100%', lg: isUploadEnabled ? '60%' : '100%' }
        }}
      >
        {files.map((file) => (
          <Grid item xs={12} sm={12} lg={12} xl={6} key={file.name}>
            <FileDownload fileName={file.name} fileUrl={file.url} fileDescription={file.date ? formatDate(file.date, 'short') : '-'} required={true} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  </Stack>;
};

export default ProfileDocuments;